import { RootState } from "redux/rootReducer";

export const selectIsVoiceCall = (state: RootState) => state.voiceCall.loading;
export const selectVoiceCallErrorMessage = (state: RootState) =>
  state.voiceCall.error;
export const voiceCallDataResponse = (state: RootState) =>
  state.voiceCall.voiceCallResponse;
